import React, { useEffect, useState } from 'react'
import matter from 'gray-matter'
// import Link from 'next/link'
import { marked } from 'marked'
import sanitize from '../../src/utils/sanitize'
// import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
// import Image from 'next/image'
import { Avatar, Box, Button, CardContent, CardHeader, Divider, Typography } from '@mui/material'
import getBlogs from '../../lib/blogs/_getBlogs'
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import getBlog from '../../lib/blogs/_getBlog';
import ShareBlog from '../../src/components/BlogPost/ShareBlog';
import useAuth from '../../src/hook/auth';
import { useRouter } from 'next/router';
import { dataConstants } from '../../src/constants';
import getPricePlans from '../../lib/pricing/_getPricePlans';
import { createBlogMetaTag } from '../../src/utils/helpers';
import GoogleAd from '../../src/components/_common/GoogleAds';

export default function PostPage({
  frontmatter: { title, date, cover_image, author, description, tags, preview },
  slug,
  content,
  pricePlans,
}) {

  const auth = useAuth();
  const { user } = auth || {}
  const { reloadUserInfo } = user || {}
  const { createdAt } = reloadUserInfo || {}
  const bots = ["googlebot", "bingbot", "slurp", "duckduckbot", "yandexbot", "facebot", "applebot"]
  const isBot = typeof window === "undefined" ? false : bots.some(el => navigator.userAgent.toLowerCase().includes(el))
  const isPremium = isBot ? true : (reloadUserInfo?.customAttributes && (JSON.parse(reloadUserInfo?.customAttributes)?.userType === "PREMIUM" || JSON.parse(reloadUserInfo?.customAttributes)?.userType === "PROFESSIONAL") ? true : false);
  const router = useRouter();

  const [plan, setPlan] = useState("Premium");
  const [plans, setPlans] = useState(pricePlans ? pricePlans : (process.env.NODE_ENV !== 'production' ? dataConstants.DEVPLANS : dataConstants.PRODPLANS));
  const premiumPlan = plans && plans.length > 0 ? plans?.find(d => d.plan.toLowerCase() === plan.toLowerCase()) : null;
  const [currency_type, set_currency_type] = useState('usd');
  // const monthlyPrice = premiumPlan && currency_type === "inr" ? premiumPlan?.im.toString() : premiumPlan?.m.toString();
  const monthlyPrice = premiumPlan?.m.toString();

  // useEffect(() => {
  //   const currentDate = new Date();
  //   if (`${currentDate}`.includes('India Standard Time')) {
  //     set_currency_type('inr')
  //   } else {
  //     set_currency_type('usd')
  //   }
  // }, [new Date()]);


  // const convertTime12to24 = time12h => {
  //   const [time, modifier] = time12h?.split(' ');
  //   let [hours, minutes, seconds] = time ? time.split(':') : null;
  //   if (hours === '12') {
  //     hours = '00';
  //   }
  //   if (modifier === 'PM') {
  //     hours = parseInt(hours, 10) + 12;
  //   }
  //   return `${hours}:${minutes}`;
  // };

  // const getDate = (date) => {
  //   let d = new Date(date);
  //   let options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
  //   let n = d.toLocaleDateString('en-US', options);
  //   let t = d.toLocaleTimeString('en-US', { timeZone: "America/New_York" })
  //   let replase = n.replace(new RegExp(',', 'g'), ' ')
  //   return `${replase} • ${convertTime12to24(t)}`
  // }

  const convertTime12to24 = time12h => {
    if (!time12h) return '';
    const [time, modifier] = time12h.split(' ');
    if (!time || !modifier) return '';
    let [hours, minutes, seconds] = time.split(':');
    if (!hours || !minutes) return '';
    if (hours === '12') {
      hours = '00';
    }
    if (modifier === 'PM') {
      hours = parseInt(hours, 10) + 12;
    }
    return `${hours}:${minutes}`;
  };

  const getDate = (date) => {
    let d = new Date(date);
    if (isNaN(d.getTime())) {
      d = new Date(date.replace(/-/g, '/'));
    }
    let options = { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' };
    let n = d.toLocaleDateString('en-US', options);
    let t = d.toLocaleTimeString('en-US', { timeZone: "America/New_York" })
    let replace = n.replace(new RegExp(',', 'g'), ' ')
    // return `${replace} • ${convertTime12to24(t)}`
    return `${replace}, ${convertTime12to24(t)}`
  }

  // const getDate = (date) => {
  //   let d = new Date(date);
  //   let n = d.toLocaleDateString('en-US', { weekday: 'short', year: 'numeric', month: 'short', day: 'numeric' });
  //   let t = d.toLocaleTimeString('en-US', { timeZone: "America/New_York" })
  //   let replase = n.replace(new RegExp(',', 'g'), ' ')
  //   return `${replase} • ${convertTime12to24(t)}`
  // }
  return (
    <>
      <Box
        sx={{
          background: '#f8f9fa',
          // boxShadow: '0 0.5px 1px rgb(132 135 154 / 20%), 0 2px 3px rgb(132 135 154 / 10%)',
          boxShadow: 'inset 0px -8px 24px rgba(214, 227, 255, 0.26)',
          // background: 'url(/images/components/banner/back2.jpg)'
          // background: 'linear-gradient(180deg, #F3F6F9 0%, #FFFFFF 100%)'
        }}>
        <Container maxWidth="lg" className='card-page' sx={{ pt: 5, pb: 1 }}>
          <Button size="small" href="/blogs" startIcon={<ArrowBackIosNewRoundedIcon />} sx={{ fontSize: '.875rem', fontWeight: 600, textTransform: "none", '& svg': { fontSize: '.9rem !important' } }}>
            Back to Blogs
          </Button>
          <Box component="div" sx={{ mt: 4 }}>
            {/* <Typography variant="caption" className='post-date' sx={{ color: 'text.very_light_desc', my: 2 }}>Posted on {date}</Typography> */}
            <Typography variant="h1" className='post-title' sx={{ fontWeight: 700, mt: 2, fontSize: { xs: '2rem', sm: '2rem', md: '3rem' } }}>{title}</Typography>
            {/* <Divider sx={{ maxWidth: '110px', margin: '10px 0 0 0', borderWidth: '2px', borderColor: '#020B4A', borderRadius: '4px' }} /> */}
            <Box sx={{ mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: { md: 'center', sm: 'start', xs: 'start' }, flexDirection: { md: 'row', sm: 'column', xs: 'column' } }}>
              {/* <CardHeader
                sx={{ px: 0 }}
                avatar={
                  <Avatar sx={{ bgcolor: 'primary.main' }}
                    alt={author}
                    aria-label="recipe"
                    src="/"
                  />
                }
                title={author}
                subheader={`Posted on ${getDate(date)}`}
              /> */}
              <CardContent sx={{ flex: '1 0 auto', px: 0 }}>
                <Typography variant="subtitle1" color="text.secondary" component="div" sx={{ fontSize: '.92rem' }}>
                  {`Posted on ${getDate(date)}`}
                </Typography>
                <Typography component="div" variant="h6" sx={{ fontSize: '1rem', fontWeight: 500 }}>
                  {author}
                </Typography>
              </CardContent>
              <ShareBlog slug={slug} title={title} />
            </Box>
            <Typography variant="body1" component="div" className='post-desc' sx={{ my: 3 }}>{description}</Typography>
          </Box>
        </Container>
        {/* <Divider sx={{ mb: 5 }} /> */}
      </Box >
      <Box component="div" className='post-body' sx={{ background: '#fff', mt: 5 }}>
        <Container maxWidth="lg" className='card-page' sx={{ pb: 4 }}>
          {isPremium ? null :
            <GoogleAd
              wrapperClass="blog-ad"
              slot="2799243600"
              format="horizontal"
              adKey={`blog-ad-1`}
              layout="in-article"
              responsive="true"
            />}
          {tags?.find(d => d === 'premium') ?
            (isPremium ?
              <Box component="div" dangerouslySetInnerHTML={{ __html: sanitize(marked(content)) }} />
              :
              <Box component="div">
                <Box component="div" className="postContent"
                  sx={{
                    pt: 5,
                  }}>
                  <Typography variant="body1" component="div" className='post-desc'>{preview}</Typography>
                </Box>
                <Box component="div" sx={{ my: 7, p: 4, textAlign: 'center', boxShadow: 2, bgcolor: 'primary.main', borderRadius: '5px' }}>
                  <Typography variant="h5" component="div" sx={{ color: '#fff', fontWeight: 500 }}>Read more from Grufity — and all premium posts from us.</Typography>
                  <Typography variant="body1" component="div" sx={{ my: 2, color: '#c0c0c0', fontSize: '.97rem' }}>
                    Become a member now for {currency_type === "inr" ? `₹` : "$"}{monthlyPrice}/month to get unlimited access.<br />You can still access all best posts from Grufity.
                  </Typography>
                  <Button href="/pricing?ref=blogs" variant="contained" sx={{ textTransform: 'none', my: 2, mx: 'auto', width: '40%', bgcolor: '#f7f7f7', color: '#000', '&:hover': { bgcolor: '#fff', color: 'primary.main' } }}>
                    {/* Try it for just $1.99 */}
                    Buy Subscription
                  </Button>
                </Box>
              </Box>)
            :
            <Box component="div" dangerouslySetInnerHTML={{ __html: sanitize(marked(content)) }} />
          }
          {isPremium ? null :
            <GoogleAd
              wrapperClass="blog-ad"
              slot="8081444157"
              format="horizontal"
              adKey={`blog-ad-2`}
              layout="in-article"
              responsive="true"
            />}
        </Container>
      </Box >
    </>
  )
}

export async function getStaticPaths() {
  const { getBlogs: blogs } = (await getBlogs()) || {}

  // Get slug and frontmatter from posts
  const paths = blogs && blogs.length > 0 ? blogs.map((blog) => ({
    params: {
      slug: blog?.urlsuffix,
    },
  })) : []

  return {
    paths,
    fallback: 'blocking',
  }
}

export async function getStaticProps({ params: { slug } }) {
  const { getBlog: markdownWithMeta } = (await getBlog(slug)) || {}
  // const { getBlogs: blogs } = (await getBlogs()) || {}

  const { plans } = (await getPricePlans()) || {}

  // Get slug and frontmatter from posts
  // const markdownWithMeta = blogs && blogs.length > 0 ? blogs.find(blog => blog?.urlsuffix === slug) : {}

  const { data: frontmatter, content } = matter(`${markdownWithMeta?.content}`) || {}
  const getMetaTags = createBlogMetaTag(frontmatter?.tags, slug, frontmatter?.title, frontmatter?.description)

  return {
    props: {
      frontmatter,
      slug,
      content,
      pricePlans: plans || {},
      meta_tags: getMetaTags || null
    },
    revalidate: dataConstants.REVALIDATE_IN.SIX_HOURS,
    // notFound: !markdownWithMeta?.content ? true : false,
    notFound: markdownWithMeta?.urlsuffix !== slug ? true : false,
  }
}
